module.exports = __webpack_public_path__ + "static/media/app_academy_logo.863bd8f7.png";